import React from "react";
import Layout from "components/Layout";
import ManualDataTable from "./components/ManualDataTable";

function Manual() {
  return (
    <Layout title="매뉴얼 목록">
      <ManualDataTable />
    </Layout>
  );
}

export default Manual;
